import { useQuery } from '@tanstack/react-query';
import {
  fetchLegacyUsers,
  type LegacyUsersListResponse,
} from '../../services/legacyUserManager';

export type LegacyConfigurationsFilter = 'all' | 'with' | 'without';
export type LegacyMigrationListFilter =
  | 'all'
  | 'pending'
  | 'ignored'
  | 'migrated';

export const legacyUsersListQueryKey = (
  page: number,
  pageSize: number,
  query: string,
  migrationStatus: string,
  configurations: string = 'all'
) =>
  [
    'admin',
    'legacy-users',
    page,
    pageSize,
    query,
    migrationStatus,
    configurations,
  ] as const;

export function useLegacyUsersListQuery(
  page: number,
  pageSize: number,
  query: string = '',
  migrationStatus: LegacyMigrationListFilter = 'all',
  configurations: LegacyConfigurationsFilter = 'all'
) {
  return useQuery<LegacyUsersListResponse>({
    queryKey: legacyUsersListQueryKey(
      page,
      pageSize,
      query,
      migrationStatus,
      configurations
    ),
    queryFn: () =>
      fetchLegacyUsers(
        page,
        pageSize,
        query || undefined,
        migrationStatus,
        configurations
      ),
    placeholderData: (previous) => previous,
  });
}
